/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Video_Encoding_ProgressInputs */

const en_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encoding video: ${i?.timecode}`)
};

const fr_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encodage vidéo : ${i?.timecode}`)
};

const de_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Videokodierung: ${i?.timecode}`)
};

const it_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codifica video: ${i?.timecode}`)
};

const ru_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Кодирование видео: ${i?.timecode}`)
};

const es_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificación de vídeo: ${i?.timecode}`)
};

const zh_cn2_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频编码：${i?.timecode}`)
};

const ja_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオのエンコード: ${i?.timecode}`)
};

const hi_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो एन्कोडिंग: ${i?.timecode}`)
};

const pt_pt2_audio_description_export_status_video_encoding_progress = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codificação de vídeo: ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Encoding video: {timecode}" |
*
* @param {Audio_Description_Export_Status_Video_Encoding_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_progress = /** @type {((inputs: Audio_Description_Export_Status_Video_Encoding_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "de") return de_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "it") return it_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "ru") return ru_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "es") return es_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "ja") return ja_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "hi") return hi_audio_description_export_status_video_encoding_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_video_encoding_progress(inputs)
	return en_audio_description_export_status_video_encoding_progress(inputs)
});